<template>
    <v-dialog max-width="600px" v-model="showDialog" @hidden="onHidden">
        <template v-slot:activator="{ on }">
            <v-btn text small @click="init" v-on="on">
                <v-icon class="blue--text">fingerprint</v-icon> huellas digitales
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                <!-- <h1 class="title">Detalle de la obra</h1> -->
            </v-card-title>

            <v-card-text>

                <h3>{{ obra.title }}</h3>
                <br />
                <h4>Artistas:</h4>
                <ul>

                    <div v-if="macheos.length == 0">Cargando . . .</div>
                    <div v-for="m in macheos" :key="m.id" class="d-flex flex-wrap my-3 align-center">
                        <v-icon v-if="m.estado == 'Internacional'" class="green-text" small>volume_up</v-icon>
                        <v-icon v-if="m.estado != 'Internacional'" class="blue--text" small>volume_up</v-icon>
                        {{ m.artistas }}
                        <span v-if="!m.artistas || m.artistas.trim().length == 0">Sin datos de artistas</span>


                        ID: <span style="width: 50px; display: inline-block; margin-left: 5px; font-size: 14px;">{{
                            m.origenId.slice(0, 5) }}
                        </span>

                        <div v-if="m.conAudio" class="d-flex">
                            <div v-if="m.playingStatus == 'Error'" class="red--text">error</div>
                            <v-btn v-if="m.playingStatus != 'Playing'" small :loading="m.playingStatus == 'Loading'"
                                color="white" @click="() => { play(m) }"><v-icon>mdi-play-circle</v-icon></v-btn>
                            <v-img v-if="m.playingStatus == 'Playing'" src="img/icons8-audio.gif"> </v-img>
                        </div>
                    </div>
                </ul>
                <audio ref="audio">
                    Your browser does not support the &lt;audio&gt; tag.
                    <source ref="source" src="" type="audio/wav" />
                </audio>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" outlined small @click="showDialog = false">Volver</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
  
<script>

import axios from 'axios';

export default {
    props: ["obra"],
    data() {
        return {
            showDialog: false,
            macheos: [],
            loading: false,
        };
    },
    methods: {
        init() {
            this.loading = true;
            axios
                .get("/miapa/macheosByCodWorkSq?codWorkSq=" + this.obra.codWorkSq)
                .then(response => {
                    this.loading = false;
                    console.log(response)
                    this.macheos = response.data.map(m => {
                        return { ...m, playingStatus: 'new' }
                    });
                })
                .catch(error => {
                    this.loading = false;
                    console.log(error);
                });
        },
        onHidden(e) {
            alert('the modal was hidden')
        },
        async play(item) {

            console.log(item);

            item.playingStatus = 'Loading';

            const { data } = await axios.get("/bmat/audio/" + item.origenId, {
                responseType: 'arraybuffer',
                headers: {
                    'Content-Type': 'audio/wav'
                }
            }).catch(() => {
                // console.log('err',err);
                item.playingStatus = 'Error';
                return { data: false };
            });

            if (!data) return;

            const blob = new Blob([data], {
                type: 'audio/wav'
            });

            const url = URL.createObjectURL(blob);

            const audio = this.$refs.audio; //document.getElementById('audio');
            const source = this.$refs.source; //document.getElementById('source');

            // Insert blob object URL into audio element & play.
            source.src = url;
            audio.load();

            audio.addEventListener('ended', () => {
                item.playingStatus = 'Stoped';
            })


            this.macheos.forEach(m => {
                if (m.playingStatus == 'Playing') {
                    m.playingStatus = 'Stopped'
                }
            });

            audio.play();
            item.playingStatus = 'Playing';
        }
    },
    mounted() {

    },
    watch: {
        showDialog: function (v) {
            if (!v) {
                const audio = this.$refs.audio;
                audio.pause();
                this.macheos.forEach(m => {
                    if (m.playingStatus == 'Playing') {
                        m.playingStatus = 'Stopped'
                    }
                });
            }
        }
    }
};
</script>
  